/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeploymentMode,
    DeploymentModeFromJSON,
    DeploymentModeFromJSONTyped,
    DeploymentModeToJSON,
} from './DeploymentMode';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';

/**
 * 
 * @export
 * @interface StbGroupRequest
 */
export interface StbGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    deviceTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    superGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    upgradeRuleId?: string | null;
    /**
     * 
     * @type {DeploymentMode}
     * @memberof StbGroupRequest
     */
    deploymentMode?: DeploymentMode;
    /**
     * 
     * @type {boolean}
     * @memberof StbGroupRequest
     */
    enableQuota?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof StbGroupRequest
     */
    bpProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StbGroupRequest
     */
    quota?: number | null;
    /**
     * 
     * @type {FirmwareType}
     * @memberof StbGroupRequest
     */
    quotaFirmwareType?: FirmwareType;
    /**
     * 
     * @type {number}
     * @memberof StbGroupRequest
     */
    quotaDailyIncrement?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    quotaBypassLoaderVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    quotaBypassFwVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    quotaBypassUiVersion?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StbGroupRequest
     */
    ipGroup?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupRequest
     */
    ipMask?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StbGroupRequest
     */
    isIpGroup?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StbGroupRequest
     */
    tagIds?: Array<string>;
}

export function StbGroupRequestFromJSON(json: any): StbGroupRequest {
    return StbGroupRequestFromJSONTyped(json, false);
}

export function StbGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StbGroupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceTypeId': !exists(json, 'deviceTypeId') ? undefined : json['deviceTypeId'],
        'superGroupId': !exists(json, 'superGroupId') ? undefined : json['superGroupId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'upgradeRuleId': !exists(json, 'upgradeRuleId') ? undefined : json['upgradeRuleId'],
        'deploymentMode': !exists(json, 'deploymentMode') ? undefined : DeploymentModeFromJSON(json['deploymentMode']),
        'enableQuota': !exists(json, 'enableQuota') ? undefined : json['enableQuota'],
        'bpProfile': !exists(json, 'bpProfile') ? undefined : json['bpProfile'],
        'quota': !exists(json, 'quota') ? undefined : json['quota'],
        'quotaFirmwareType': !exists(json, 'quotaFirmwareType') ? undefined : FirmwareTypeFromJSON(json['quotaFirmwareType']),
        'quotaDailyIncrement': !exists(json, 'quotaDailyIncrement') ? undefined : json['quotaDailyIncrement'],
        'quotaBypassLoaderVersion': !exists(json, 'quotaBypassLoaderVersion') ? undefined : json['quotaBypassLoaderVersion'],
        'quotaBypassFwVersion': !exists(json, 'quotaBypassFwVersion') ? undefined : json['quotaBypassFwVersion'],
        'quotaBypassUiVersion': !exists(json, 'quotaBypassUiVersion') ? undefined : json['quotaBypassUiVersion'],
        'ipGroup': !exists(json, 'ipGroup') ? undefined : json['ipGroup'],
        'ipMask': !exists(json, 'ipMask') ? undefined : json['ipMask'],
        'isIpGroup': !exists(json, 'isIpGroup') ? undefined : json['isIpGroup'],
        'tagIds': !exists(json, 'tagIds') ? undefined : json['tagIds'],
    };
}

export function StbGroupRequestToJSON(value?: StbGroupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceTypeId': value.deviceTypeId,
        'superGroupId': value.superGroupId,
        'name': value.name,
        'description': value.description,
        'upgradeRuleId': value.upgradeRuleId,
        'deploymentMode': DeploymentModeToJSON(value.deploymentMode),
        'enableQuota': value.enableQuota,
        'bpProfile': value.bpProfile,
        'quota': value.quota,
        'quotaFirmwareType': FirmwareTypeToJSON(value.quotaFirmwareType),
        'quotaDailyIncrement': value.quotaDailyIncrement,
        'quotaBypassLoaderVersion': value.quotaBypassLoaderVersion,
        'quotaBypassFwVersion': value.quotaBypassFwVersion,
        'quotaBypassUiVersion': value.quotaBypassUiVersion,
        'ipGroup': value.ipGroup,
        'ipMask': value.ipMask,
        'isIpGroup': value.isIpGroup,
        'tagIds': value.tagIds,
    };
}

